import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const r=i("waves",t`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            static
        >
            <g clip-path="url(#clip0_4874_1075)">
                <path
                    d="M0.000488281 12.5L12.0003 0.500146L24.0002 12.5L12.0003 24.4999L0.000488281 12.5Z"
                    fill="#0055FE"
                />
            </g>
            <defs>
                <clipPath id="clip0_4874_1075">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    `);export{r as Waves};
